import script from "./ViewCreateTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewCreateTeam.vue?vue&type=script&setup=true&lang=js"

import "./ViewCreateTeam.vue?vue&type=style&index=0&id=7e2c1ca6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2c1ca6"]])

export default __exports__